import type { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { getParameter } from "../../store/app/general";
import DatepickerInput from "../elements/datepicker/datepicker";
import StationPicker from "../elements/stationpicker/stationpicker";
import { useKeydownListener } from "../../hooks/useKeydownListener";
import { useCallback, useEffect, useRef } from "react";
import ORMfunctions from "../../hooks/app/general";

function SearchModal(props: any) {
  const deliveryStation = useSelector((state: RootState) =>
    getParameter(state, "BINET_ALLOW_ONEWAY"),
  );

  const containerRef = useRef<HTMLDivElement>(null);

  const options = useSelector(
    (state: RootState) => state.general.stationpickerOptions,
  );
  useEffect(() => {
    containerRef.current?.focus();
  });
  const mode = props.mode;

  // Keyboard navigation
  const handleKeydown = useCallback((event: KeyboardEvent) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "Enter":
        console.log(event.target!);

        break;
      case "Escape":
        event.preventDefault();
        props.close();
        break;
      case "Tab":
        break;
      default:
        break;
    }
  }, []);

  useKeydownListener(containerRef, handleKeydown);
  if (mode !== "inner")
    return (
      <div
        className="orm-html orm-modal orm-modal--stationtime orm-modal--overflowAuto"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
        ref={containerRef}
      >
        <div className="orm-container">
          <div className="orm-row center-xs middle-xs orm-h100vh">
            <div className="orm-col-xs-12 orm-col-sm-10 orm-col-md-6 orm-col-lg-4">
              <div
                className="orm-modal__inner orm-modal__inner--fullheight orm-pt-60 orm-pb-30 orm-px-8 orm-px-xs-30 orm-relative"
                tabIndex={-1}
                aria-modal="true"
                role="alertdialog"
                id="`modal-${$.uid}`"
              >
                <button
                  tabIndex={0}
                  className="orm-btn__small--black orm-btn__small--topright float-right"
                  aria-label="Schließen"
                  onClick={() => props.close()}
                >
                  <i className="fas fa-times"></i>
                </button>
                <div className="orm-row">
                  <div className="orm-relative orm-col-xs-12">
                    <StationPicker
                      type="start"
                      useinputsearch={options.useinputsearch}
                      useapi={options.useapi}
                      regioncodes={options.regioncodes}
                      rangelimit={options.rangelimit}
                      resultlimit={options.resultlimit}
                      enabledstations={props.enabledstations}
                    />

                    {deliveryStation ? (
                      <StationPicker
                        type="end"
                        useinputsearch={options.useinputsearch}
                        useapi={options.useapi}
                        regioncodes={options.regioncodes}
                        rangelimit={options.rangelimit}
                        resultlimit={options.resultlimit}
                        enabledstations={props.enabledstations}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="orm-mb-16">
                  {" "}
                  <DatepickerInput type="modal" />
                </div>

                <button
                  className="orm-btn orm-btn--large"
                  onClick={() => {
                    window.location.href = "/reservation/step1";
                  }}
                >
                  suchen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  else
    return (
      <div
        className="orm-html orm-modal orm-modal--inner"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
        ref={containerRef}
      >
        <div
          className="orm-modal__inner orm-modal__inner--fullheight orm-pt-60 orm-pb-30 orm-px-8 orm-px-xs-30 orm-relative"
          tabIndex={-1}
          aria-modal="true"
          role="alertdialog"
          id="`modal-${$.uid}`"
        >
          <button
            tabIndex={0}
            className="btn__small--black btn__small--topright float-right"
            aria-label="Schließen"
            onClick={() => props.close()}
          >
            <i className="fas fa-times"></i>
          </button>
          <div className="orm-relative orm-col-xs-12">
            <StationPicker
              type="start"
              useinputsearch={options.useinputsearch}
              useapi={options.useapi}
              regioncodes={options.regioncodes}
              rangelimit={options.rangelimit}
              resultlimit={options.resultlimit}
              enabledstations={props.enabledstations}
            />

            {deliveryStation ? (
              <StationPicker
                type="end"
                useinputsearch={options.useinputsearch}
                useapi={options.useapi}
                regioncodes={options.regioncodes}
                rangelimit={options.rangelimit}
                resultlimit={options.resultlimit}
                enabledstations={props.enabledstations}
              />
            ) : (
              <></>
            )}
          </div>
          <DatepickerInput type="modal" />

          <button
            className="orm-btn orm-btn--large"
            onClick={() => {
              window.location.href =
                ORMfunctions.baseLang() + "/reservation/step1";
            }}
          >
            {ORMfunctions.i18n("general/showOffers")}
          </button>
        </div>
      </div>
    );
}

export default SearchModal;
